import React from "react";
import AnalyticsTableData from "./AnalyticsTableData";

const AnalyticsTable = ({ graphData }) => {
  return (
    <>
      <div className="analytics-main-list my-2 py-1 d-flex justify-content-between flex-column">
        <div className="analytics-container text-nowrap">
          <table className="main-table">
            <thead>
              <tr className="table-rows">
                <th className="table-heads" width={"5%"}>
                  #
                </th>
                <th className="table-heads" width={"12%"}>
                  Order ID
                </th>
                <th className="table-heads" width={"15%"}>
                  Customer name
                </th>
                <th className="table-heads" width={"15%"}>
                  Order Date
                </th>
                <th className="table-heads" width={"12%"}>
                  Order Value
                </th>
                <th className="table-heads-action" width={"15%"}>
                  Order Status
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {graphData?.completedOrders.length > 0 ? (
                graphData?.completedOrders?.map((ele, index) => (
                  <AnalyticsTableData tableData={ele} index={index} />
                ))
              ) : (
                <tr>
                  <td
                    colSpan="1"
                    className="text-center no-data-container fs_16"
                  >
                    <span>~ No Data Found ~</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AnalyticsTable;
